import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

/**
 * Interpreta um campo "data pura" (ex: dueDate) como meia-noite LOCAL.
 *
 * O backend guarda esses campos como `date` (YYYY-MM-DD) e às vezes os serializa
 * como `YYYY-MM-DDT00:00:00.000Z`. `new Date(...)` leria ambos como meia-noite UTC,
 * o que em fusos negativos (BRT = UTC-3) joga a data para o dia anterior e faz uma
 * cobrança que vence hoje parecer vencida.
 */
export function parseDateOnly(date: string | Date | undefined | null): Date | null {
  if (!date) return null;
  if (date instanceof Date) return isNaN(date.getTime()) ? null : date;

  const datePart = date.trim().split('T')[0];
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
  if (!match) {
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  const [, year, month, day] = match;
  return new Date(Number(year), Number(month) - 1, Number(day));
}

export function formatDate(date: string | Date | undefined | null, pattern = 'dd/MM/yyyy'): string {
  if (!date) return '';
  try {
    let dateObj: Date;

    if (typeof date === 'string') {
      // Check if it's a date-only string in ISO format (YYYY-MM-DD)
      const dateOnlyRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (dateOnlyRegex.test(date.trim())) {
        // Parse as local date to avoid timezone conversion
        dateObj = parseDateOnly(date) as Date;
      } else {
        dateObj = new Date(date);
      }
    } else {
      dateObj = date;
    }

    if (isNaN(dateObj.getTime())) return 'Data inválida';
    return format(dateObj, pattern, { locale: ptBR });
  } catch (error) {
    console.error('Error formatting date:', date, error);
    return 'Data inválida';
  }
}

export function formatTime(time: string | undefined | null, includeSeconds = false): string {
  if (!time) return '';
  try {
    const parts = time.split(':');
    if (parts.length < 2) return time;
    return includeSeconds ? time : `${parts[0]}:${parts[1]}`;
  } catch {
    return time;
  }
}
